import { render, staticRenderFns } from "./event-test-dialog.vue?vue&type=template&id=d885faea"
import script from "./event-test-dialog.vue?vue&type=script&lang=js"
export * from "./event-test-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports